import Vue from 'vue';
import IdealPostcodesVue from 'ideal-postcodes-vue';

Vue.use(IdealPostcodesVue, {
    key: 'ak_kbrsuh3y7fN2wc6ZLZRO8hf20ICfr',
});
